import { Trans, useTranslation } from "react-i18next";
import reasonsToLoveIllustration from "@static/img/home/mobileReasonsToLove.png";
import { HomeMarketingInformationCards } from "@features/home/common/HomeMarketingInformationCards/HomeMarketingInformationCards";
import { useStyle } from "@features/home/mobile/HomeMobileReasonsToLove/style";
import { useDeviceType } from "@hooks/useDeviceType";
import { Link } from "@mui/material";
import { WORDPRESS_URL } from "@constants";

export const HomeMobileReasonsToLove = () => {
    const { t } = useTranslation("home");
    const { isMobileOrTablet, isMobile } = useDeviceType();
    const { classes } = useStyle({ isMobileOrTablet, isMobile });

    const wifiCardsInfos = [
        {
            title: t("mobileReasonsToLove.priceForLife.title"),
            description: t("mobileReasonsToLove.priceForLife.description"),
        },
        {
            title: t("mobileReasonsToLove.reliableNetwork.title"),
            description: t("mobileReasonsToLove.reliableNetwork.description"),
        },
        {
            title: t("mobileReasonsToLove.awardWinning.title"),
            description: (
                <Trans
                    components={[
                        <Link
                            color="primary"
                            href={`${WORDPRESS_URL}/about-gomo/`}
                            key="about-gomo-link"
                            rel="noopener noreferrer"
                            target="_blank"
                            underline="always"
                        />,
                    ]}
                    i18nKey="mobileReasonsToLove.awardWinning.description"
                    ns="home"
                />
            ),
        },
        {
            title: t("mobileReasonsToLove.goESIM.title"),
            description: t("mobileReasonsToLove.goESIM.description"),
        },
    ];

    return (
        <div className={classes.container}>
            <HomeMarketingInformationCards
                cardsInfos={wifiCardsInfos}
                imageAlt={t("mobileReasonsToLove.imageAlt")}
                imageSrc={reasonsToLoveIllustration}
                title={t("mobileReasonsToLove.title")}
            />
        </div>
    );
};
